<template>
  <div>
    <div class="center-main">
      <!-- ===== 顶部固定区域 ===== -->
      <div class="top-fixed">
        <div class="header-title">个人中心</div>
        <div class="border_postion">
          <div class="person-card">
            <div class="person-card-content">
              <!--个人中心-头像部分-->
              <div class="header-part">
                <div class="header-img">
                  <van-image
                    round
                    width="100%"
                    height="100%"
                    :src="headerImg"
                  />
                </div>
                <div class="header-body">
                  <div class="person-account">
                    个人账号：{{ userInfo.userName }}
                  </div>
                  <div class="person-money-addr">
                    收款地址：{{
                      backInfo.backCardName ? maskMiddle(backInfo.backCardName) : "--"
                    }}
                    <span
                      ><button
                        type="text"
                        v-clipboard:copy="backInfo.backCardName"
                        v-clipboard:success="onCopy"
                        v-clipboard:error="onError"
                      >
                        点击复制
                      </button></span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="person-card">
            <div class="person-card-content-second">
              <div class="item-second-content">
                {{
                  customerMoneyInfo.balanceMoney
                    ? customerMoneyInfo.balanceMoney
                    : "--"
                }}
                <div>余额(元)</div>
              </div>
              <div class="line-area"></div>
              <div class="item-second-content">
                {{
                  customerOrderDataVo == null
                    ? 0
                    : customerOrderDataVo.proccessOrders
                }}
                <div>进行中</div>
              </div>
              <div class="line-area"></div>
              <div class="item-second-content">
                {{
                  customerOrderDataVo == null
                    ? 0
                    : customerOrderDataVo.finishOrders
                }}
                <div>已完成</div>
              </div>
              <div class="line-area"></div>
              <div class="item-second-content">
                {{
                  customerOrderDataVo == null
                    ? 0
                    : customerOrderDataVo.cancelOrders
                }}
                <div>已取消</div>
              </div>
            </div>
          </div>
        </div>
        <div class="border_postion">
          <div class="middle-car" style="background-color: #ffffff;">
            <div style="width: 100%;margin: 6px;">
              <van-grid :column-num="4" :gutter="10" :border="false">
                <van-grid-item @click="rechargeMoney">
                  <van-icon
                    size="calc(2.2rem + 2.5vw)"
                    :name="require('../../assets/img/vip_recharge.png')"
                  />
                  <div style="font-size: smaller;margin-top: 5px">立即充值</div>
                </van-grid-item>
                <van-grid-item :to="{ path: '/home/cashoutmoney' }">
                  <van-icon
                    size="calc(2.2rem + 2.5vw)"
                    :name="require('../../assets/img/vip_cashout.png')"
                  />
                  <div style="font-size: smaller;margin-top: 5px">我要提现</div>
                </van-grid-item>
                <van-grid-item :to="{ path: '/home/transfermoney' }">
                  <van-icon
                    size="calc(2.2rem + 2.5vw)"
                    :name="require('../../assets/img/vip_transfer.png')"
                  />
                  <div style="font-size: smaller;margin-top: 5px">站内转账</div>
                </van-grid-item>
                <van-grid-item @click="bindReciveMoney">
                  <van-icon
                    size="calc(2.2rem + 2.5vw)"
                    :name="require('../../assets/img/vip_setaddr.png')"
                  />
                  <div style="font-size: smaller;margin-top: 5px">设置地址</div>
                </van-grid-item>
              </van-grid>
            </div>
          </div>
        </div>
      </div>
      <!-- /.top-fixed -->

      <!-- ===== 底部可滚动区域 ===== -->
      <div class="scroll-area">

      <div style="background-color: #ffffff;margin-top: 0;">
        <!-- 权益统计 -->
        <van-cell
          icon="chart-trending-o"
          title="收益统计"
          @click="benefitExpanded = !benefitExpanded"
        >
          <template #right-icon>
            <van-icon
              name="arrow"
              class="benefit-arrow"
              :class="{ 'benefit-arrow--expanded': benefitExpanded }"
            />
          </template>
        </van-cell>
        <div class="benefit-table" v-show="benefitExpanded">
          <div class="benefit-loading-mask" v-if="benefitLoading">
            <van-loading size="20" type="spinner" color="#1989fa" />
          </div>
          <div class="benefit-header">
            <span class="benefit-label"></span>
            <span class="benefit-value">收益</span>
            <span class="benefit-value">订单</span>
            <span class="benefit-value">推荐</span>
          </div>
          <div class="benefit-row">
            <span class="benefit-label">当日</span>
            <span class="benefit-value">{{ benefitStatistics.todayProfit || 0 }}</span>
            <span class="benefit-value">{{ benefitStatistics.todayOrders || 0 }}</span>
            <span class="benefit-value">{{ benefitStatistics.todayRecommend || 0 }}</span>
          </div>
          <div class="benefit-row">
            <span class="benefit-label">昨日</span>
            <span class="benefit-value">{{ benefitStatistics.yesterdayProfit || 0 }}</span>
            <span class="benefit-value">{{ benefitStatistics.yesterdayOrders || 0 }}</span>
            <span class="benefit-value">{{ benefitStatistics.yesterdayRecommend || 0 }}</span>
          </div>
          <div class="benefit-row">
            <span class="benefit-label">当月</span>
            <span class="benefit-value">{{ benefitStatistics.monthProfit || 0 }}</span>
            <span class="benefit-value">{{ benefitStatistics.monthOrders || 0 }}</span>
            <span class="benefit-value">{{ benefitStatistics.monthRecommend || 0 }}</span>
          </div>
          <div class="benefit-row">
            <span class="benefit-label">总计</span>
            <span class="benefit-value">{{ benefitStatistics.totalProfit || 0 }}</span>
            <span class="benefit-value">{{ benefitStatistics.totalOrders || 0 }}</span>
            <span class="benefit-value">{{ benefitStatistics.totalRecommend || 0 }}</span>
          </div>
        </div>
        <van-cell
          icon="envelop-o"
          title="邀请码"
          :value="shareCode != null ? shareCode : '未开通分享码'"
          @click="goShareCenter"
          is-link
        />
        <van-cell
          icon="gold-coin-o"
          title="资金记录"
          @click="goToMoneylist"
          is-link
        />
        <!-- <van-cell
          icon="info-o"
          title="用户状态"
          :value="queryStatus(userInfo.status)"
          is-link
        /> -->

        <van-cell
          icon="refund-o"
          title="我的佣金"
          @click="goToCommssionlist"
          is-link
        />
        <van-cell
          icon="closed-eye"
          title="设置密码找回"
          @click="confirmAddQuestion"
          is-link
        />
        <van-cell
          icon="chat-o"
          title="联系客服"
          @click="connectService"
          is-link
        />
        <van-cell
          icon="chat-o"
          title="使用教程"
          @click="goToTeacherPageList"
          is-link
        />
      </div>

      <div
        style="width: 100%;margin-top: 1rem;padding: 6px 0;background-color: #ffffff; flex-shrink: 0;"
      >
        <van-row style="">
          <van-col span="24">
            <van-button
              type="danger"
              size="small"
              style="width: 100%;background-color: transparent;border: 0;color: orange;"
              @click="logout"
              >注销</van-button
            >
          </van-col>
        </van-row>
      </div>
      </div>
      <!-- /.scroll-area -->

      <!-- <van-row
        :gutter="2"
        :style="{ 'background-color': tabbarbackgroundcolor }"
      >
        <van-col :span="6">
          <van-image
            round
            width="4rem"
            height="4rem"
            :src="userLogo"
            style="margin: 10px"
          />
        </van-col>
        <van-col :span="12">
          <div
            style="text-align: left;margin-top: 0.9rem;margin-bottom:0.1rem;font-size: small;color: white"
          >
            <div>用户ID:{{ userInfo.userId }}</div>
            <div>用户名:{{ userInfo.userName }}</div>
            <div>身份证:{{ queryStatus(userInfo.status) }}</div>
            <div>上级ID:{{ userInfo.upUserId }}</div>
          </div>
        </van-col>
        <van-col :span="6">
          <div class="qr-contiuner">
            <van-icon
              name="qr"
              size="40"
              style="padding: 1.25rem"
              @click="goShareCenter"
            />
            <div style="width: 100%;text-align: center;margin-top: -20px;">
              分享
            </div>
          </div>
        </van-col>
      </van-row>
      <van-row gutter="2" style="background-color: white;margin-top: 1px">
        <van-col span="24">
          <van-grid :column-num="5">
            <van-grid-item
              :to="{
                path: '/home/mymoneycenter',
                query: {
                  balanceMoney: customerMoneyInfo.balanceMoney,
                  cashOutProcMoney: customerMoneyInfo.cashOutProcMoney,
                  selected: 0,
                },
              }"
            >
              <div style="font-size: smaller">
                {{
                  customerMoneyInfo.balanceMoney
                    ? customerMoneyInfo.balanceMoney
                    : 0
                }}
              </div>
              <div style="font-size: smaller;margin-top: 5px">账户余额</div>
            </van-grid-item>
            <van-grid-item
              :to="{
                path: '/home/mymoneycenter',
                query: {
                  balanceMoney: customerMoneyInfo.balanceMoney,
                  cashOutProcMoney: customerMoneyInfo.cashOutProcMoney,
                  selected: 0,
                },
              }"
            >
              <div style="font-size: smaller">
                {{
                  customerMoneyInfo.totalProfit
                    ? customerMoneyInfo.totalProfit
                    : 0
                }}
              </div>
              <div style="font-size: smaller;margin-top: 5px">累计收益</div>
            </van-grid-item>
            <van-grid-item
              :to="{
                path: '/home/mymoneycenter',
                query: {
                  balanceMoney: customerMoneyInfo.balanceMoney,
                  cashOutProcMoney: customerMoneyInfo.cashOutProcMoney,
                  selected: '2021080004',
                },
              }"
            >
              <div style="font-size: smaller">
                {{
                  customerMoneyInfo.cashOutProcMoney
                    ? customerMoneyInfo.cashOutProcMoney
                    : 0
                }}
              </div>
              <div style="font-size: smaller;margin-top: 5px">提现中</div>
            </van-grid-item>
            <van-grid-item :to="{ path: '/home/usertaskmgelist' }">
              <div style="font-size: smaller">
                {{
                  customerMoneyInfo.totalOrderNum
                    ? customerMoneyInfo.totalOrderNum
                    : 0
                }}
              </div>
              <div style="font-size: smaller;margin-top: 5px">总接单量</div>
            </van-grid-item>
            <van-grid-item
              style="color: #04befe"
              icon="gold-coin-o"
              text="提现"
              :to="{ path: '/home/cashoutmoney' }"
            />
          </van-grid>
        </van-col>
      </van-row>
      <van-row gutter="2" style="background-color: white;margin-top: 1px">
        <van-col span="24">
          <van-grid :column-num="5">
            <van-grid-item
              :to="{ path: '/home/usertaskmgelist', query: { status: 2 } }"
            >
              <div style="font-size: smaller">
                {{
                  customerOrderDataVo != null &&
                  customerOrderDataVo.waitReviewOrders
                    ? customerOrderDataVo.waitReviewOrders
                    : 0
                }}
              </div>
              <div style="font-size: smaller;margin-top: 5px">待审核</div>
            </van-grid-item>
            <van-grid-item
              :to="{ path: '/home/usertaskmgelist', query: { status: 3 } }"
            >
              <div style="font-size: smaller">
                {{
                  customerOrderDataVo != null &&
                  customerOrderDataVo.waitOpertionOrders
                    ? customerOrderDataVo.waitOpertionOrders
                    : 0
                }}
              </div>
              <div style="font-size: smaller;margin-top: 5px">待操作</div>
            </van-grid-item>
            <van-grid-item
              :to="{ path: '/home/usertaskmgelist', query: { status: 4 } }"
            >
              <div style="font-size: smaller">
                {{
                  customerOrderDataVo != null &&
                  customerOrderDataVo.sendGoodProcessOrders
                    ? customerOrderDataVo.sendGoodProcessOrders
                    : 0
                }}
              </div>
              <div style="font-size: smaller;margin-top: 5px">发货中</div>
            </van-grid-item>
            <van-grid-item
              :to="{ path: '/home/usertaskmgelist', query: { status: 5 } }"
            >
              <div style="font-size: smaller">
                {{
                  customerOrderDataVo != null &&
                  customerOrderDataVo.waitAppraiseOrders
                    ? customerOrderDataVo.waitAppraiseOrders
                    : 0
                }}
              </div>
              <div style="font-size: smaller;margin-top: 5px">待评价</div>
            </van-grid-item>
            <van-grid-item
              style="color: #04befe"
              icon="orders-o"
              text="全部任务"
              :to="{ path: '/home/usertaskmgelist' }"
            />
          </van-grid>
        </van-col>
      </van-row>
      <van-row gutter="2" style="background-color: white;margin-top: 1px">
        <van-col span="24">
          <van-grid :column-num="4">
            <van-grid-item @click="bindAccountInfo">
              <van-icon name="manager-o" />
              <div style="font-size: smaller;margin-top: 5px">充值</div>
            </van-grid-item>
            <van-grid-item @click="idCardInfo">
              <van-icon name="friends-o" />
              <div style="font-size: smaller;margin-top: 5px">提现</div>
            </van-grid-item>
            <van-grid-item>
              <van-icon name="gold-coin-o" />
              <div style="font-size: smaller;margin-top: 5px">转账</div>
            </van-grid-item>
            <van-grid-item @click="bindReciveMoney">
              <van-icon name="cash-on-deliver" />
              <div style="font-size: smaller;margin-top: 5px">设置地址</div>
            </van-grid-item>
            <van-grid-item
              :to="{ path: '/home/customerappeal', query: { selected: 0 } }"
            >
              <van-icon name="certificate" />
              <div style="font-size: smaller;margin-top: 5px">申诉中心</div>
            </van-grid-item>
            <van-grid-item :to="{ path: '/home/imessagelist' }">
              <van-badge :content="unReadNum">
                <van-icon name="chat-o" />
                <div style="font-size: smaller;margin-top: 5px">站内信</div>
              </van-badge>
            </van-grid-item>
            <van-grid-item v-for="item in threeDataInfo" :key="item.dataKey">
              <div style="font-size: smaller">{{ item.dataVal }}</div>
              <div style="font-size: smaller;margin-top: 5px">
                {{ item.dataKey }}
              </div>
            </van-grid-item>
            <van-grid-item :to="{ path: '/home/changepwd' }">
              <van-icon name="closed-eye" />
              <div style="font-size: smaller;margin-top: 5px">修改密码</div>
            </van-grid-item>
          </van-grid>
        </van-col>
      </van-row>
      <van-row style="margin-top: 1px">
        <van-col span="24">
          <van-button
            type="danger"
            size="small"
            style="width: 100%"
            @click="logout"
            >注销</van-button
          >
        </van-col>
      </van-row> -->
    </div>
    <van-dialog
      v-model="showPwdDialog"
      title="添加密码找回问题"
      @confirm="addQuestion"
      show-cancel-button
      style="text-align: center"
    >
      <van-field
        v-model="questions"
        name="问题"
        label="问题："
        placeholder="请输入问题"
        :rules="[{ required: true, message: '请填写问题' }]"
      ></van-field>
      <van-field
        v-model="answer"
        name="答案"
        label="答案："
        placeholder="请输入答案"
        :rules="[{ required: true, message: '请填写答案' }]"
      ></van-field>
    </van-dialog>
    <!-- 试客公告弹窗：一次只弹一条，关闭当前这条后接着弹出下一条，直到全部展示完 -->
    <van-dialog
      v-if="customerNotic.length > 0"
      v-model="isShow"
      @confirm="todayIsNotShow"
      @cancel="closeNotice"
      @closed="onDialogClosed"
      confirm-button-text="今日不再展示"
      :show-confirm-button="true"
      :show-cancel-button="true"
    >
      <div style="margin: 3%;">
        <van-row>
          <van-col :span="22" style="margin: 1%; margin-top: 2%;">
            <div style="font-weight: bolder">{{ customerNotic[0].noticeTitle }}</div>
            <span style="font-size: xx-small">{{ customerNotic[0].createTime }}</span>
          </van-col>
        </van-row>
        <van-row>
          <van-col :span="22" style="margin: 1%">
            <!-- <div v-html="item.noticeContent"></div> -->
            <div class="notice-wrapper">
              <div v-html="customerNotic[0].noticeContent" class="notice-content"></div>
            </div>
          </van-col>
        </van-row>
      </div>
    </van-dialog>
    <!--<RejectExtraReviewDialog  :showedialog="showReject" :list="extraOrderList" @rejectExtraReview="rejectExtra"></RejectExtraReviewDialog>-->
  </div>
</template>

<script>
import {
  getCustomerInfo,
  queryUserQuestion,
  saveUserQuestion,
} from "../../api/system/sys_user";
import { MessageBox } from "mint-ui";
import {
  getCustomerMoneyInfo,
  getBackCard,
} from "../../api/system/sys_backInfo";
import {
  queryNotice,
  updateNotice,
  updateNoticeIsNotToday,
  queryBenefitStatistics,
  queryUnReadMsgNum,
} from "../../api/system/sys_personcenter";
import { queryCustomeSetting } from "../../api/system/sys_plateform";
import {
  queryIsOpenShareCode,
  queryShareCode,
} from "../../api/system/sys_sharecode";
import { Dialog, Toast } from "vant";
import {
  queryExtraOrder,
  queryIsHavaPrompReview,
  rejectExtraReviewOperInfo,
} from "../../api/system/mobile_taskorder";
import RejectExtraReviewDialog from "../../components/RejectExtraReviewDialog";


export default {
  name: "VipMemberCenter",
  components: { RejectExtraReviewDialog },
  data() {
    return {
      userInfo: {
        userId: 2,
        userName: "",
        userCard: "审核通过",
      },
      headerImg: require("../../assets/header.png"),
      noticList: [],
      customerNotic: [],
      isShow: false,
      customerMoneyInfo: {},
      extraOrderList: [],
      showReject: false,
      tabbarbackgroundcolor: "#5995fd",
      userLogo: "https://img01.yzcdn.cn/vant/cat.jpeg",
      customerOrderDataVo: {},
      threeDataInfo: [
        {
          dataKey: "待商家返款",
          dataVal: "0.00",
        },
      ],
      isBindAccount: false,
      isRecivewAccount: false,
      userStatus: false,
      questions: null,
      answer: null,
      showDialog: false,
      showPwdDialog: false,
      unReadNum: 0,
      backInfo: {
        backCardName: "",
      },
      shareCode: null,
      benefitExpanded: false,
      benefitLoading: true,
      benefitStatistics: {
        todayProfit: 0,
        todayOrders: 0,
        todayRecommend: 0,
        yesterdayProfit: 0,
        yesterdayOrders: 0,
        yesterdayRecommend: 0,
        monthProfit: 0,
        monthOrders: 0,
        monthRecommend: 0,
        totalProfit: 0,
        totalOrders: 0,
        totalRecommend: 0,
      },
    };
  },
  mounted() {
    this.$emit("titleChange", "会员中心");
    getBackCard().then((res) => {
      if (res.success) {
        console.log(res.data);
        this.backInfo = res.data ? res.data : {};
      }
    });
    queryCustomeSetting().then((res) => {
      if (res.success) {
        this.userLogo = res.data.customerLogo;
        this.tabbarbackgroundcolor = res.data.customerThemeStyle;
      }
    });
    getCustomerInfo()
      .then((res) => {
        if (res.success) {
          this.userInfo = res.data;
        }
      })
      .catch((err) => {
        MessageBox({
          title: "提示",
          message: err.message,
          showCancelButton: true,
        });
      });
    getCustomerMoneyInfo()
      .then((res) => {
        if (res.success) {
          this.customerMoneyInfo = res.data.customerMoneyInfoVo;
          this.customerOrderDataVo = res.data.customerOrderDataVo;
          this.isBindAccount = res.data.isBindAccount;
          this.isRecivewAccount = res.data.isRecivewAccount;
          this.userStatus = res.data.userStatus;
          this.$forceUpdate();
          this.showDialgWithCustomerInfo();
        }
      })
      .catch((err) => {
        MessageBox({
          title: "提示",
          message: err.message,
          showCancelButton: true,
        });
      });
    queryUnReadMsgNum().then((res) => {
      if (res.success) {
        this.unReadNum = res.data;
        this.$forceUpdate();
      }
    });

    //追评
    queryExtraOrder().then((res) => {
      if (res.success && res.data != null && res.data.length > 0) {
        Dialog.confirm({
          title: "追评",
          message: "你有追评订单，请处理。",
          confirmButtonText: "追加评价",
          showCancelButton: false,
        })
          .then(() => {
            this.$router.push({
              path: "/home/usertaskmgelist",
              query: { status: 10 },
            });
          })
          .catch(() => {
            console.log("cancel");
            //this.extraOrderList = res.data;
            //this.showReject = true
          });
      }
    });

    //如果有催评，弹对话框确认
    queryIsHavaPrompReview()
      .then((res) => {
        if (res.success) {
          if (res.data) {
            MessageBox.confirm(
              "有订单正在催评中，不允许接单及提现请尽快处理。",
              "催评提示",
              { showCancelButton: true },
            ).then((action) => {
              this.$router.push({
                path: "/home/usertaskmgelist",
                query: { status: 8 },
              });
            });
          }
        }
      })
      .catch((err) => {
        MessageBox({
          title: "提示",
          message: err.message,
          showCancelButton: true,
        });
      });

    queryNotice({ searchKeyWord: null }, { pageNum: 1, pageSize: 20 }).then(
      (res) => {
        if (res.success) {
          this.noticList = res.data.records;
          this.isNeedShow();
        }
      },
    );

    //分享码
    queryIsOpenShareCode().then((res) => {
      if (res.data) {
        queryShareCode().then((res) => {
          if (res.success) {
            this.shareCode = res.data;
          }
        });
      }
    });

    //修改密码问题
    queryUserQuestion().then((res) => {
      if (res.success && res.data) {
        //console.log(res.data)
        this.questions = res.data.userQuestion;
        this.answer = res.data.userAnswer;
      }
    });

    //权益统计
    this.benefitLoading = true;
    queryBenefitStatistics().then((res) => {
      if (res.success && res.data) {
        this.benefitStatistics = res.data;
      }
    }).finally(() => {
      this.benefitLoading = false;
    });
  },
  computed: {
    isUserStatus() {
      return function() {
        return this.userStatus != 1 && this.userStatus != 0;
      };
    },
    queryStatus() {
      return function(status) {
        if (status == "202111300001") {
          return "待审核";
        }

        if (status == "202206060001") {
          return "审核中";
        }

        if (status == "202111300002") {
          return "审核未通过";
        }

        if (status == "202111300003") {
          return "审核通过";
        }
      };
    },
  },
  methods: {
    maskMiddle(str, keepStart = 3, keepEnd = 5, mask = "***") {
      const minLen = keepStart + keepEnd;
      if (str.length > minLen) {
        return str.slice(0, keepStart) + mask + str.slice(-keepEnd);
      }
      return str;
    },
    onCopy(e) {
      //alert('复制成功！: ' + e.text)
      Toast.success("复制成功！");
    },
    onError(e) {
      Toast.fail("你的浏览器不支持复制拷贝！");
    },
    confirmAddQuestion() {
      this.showPwdDialog = true;
    },
    addQuestion() {
      saveUserQuestion(this.questions, this.answer).then((res) => {
        if (res.success) {
          Dialog.alert({ message: "更新成功！" });
        }
      });
    },
    goToTeacherPageList() {
      this.$router.push({ path: "/chat/teach" });
    },
    /*
    rejectExtra(order){
      rejectExtraReviewOperInfo(order).then(res=>{
        if (res.success){
          this.showReject = false
          Toast(res.data);
        }
      }).catch(err => {
        MessageBox({
          title: '提示',
          message: err.message,
          showCancelButton: true
        });
      });
    },
     */
    // 点击“今日不再展示”：把当前这条公告记录为今日不再展示
    // 弹窗随后会自动收起，收起动画结束后在 onDialogClosed 里弹出下一条
    todayIsNotShow() {
      if (this.customerNotic.length === 0) {
        return;
      }
      const cur = this.customerNotic[0];
      cur.isNotToday = true;
      updateNoticeIsNotToday(cur.id).then(() => {
        // 已记录成功，无需重新拉取列表，避免公告重复弹出
      }).catch(() => {
        console.log("updateNoticeIsNotToday error");
      });
    },
    // 点击取消/关闭：直接收起当前这条（不设置为今日不再展示）
    closeNotice() {
      // 弹窗会自行关闭，在 onDialogClosed 中继续弹出下一条
    },
    // 当前弹窗完全关闭后：移除已处理的一条，若还有公告则接着弹出下一条
    onDialogClosed() {
      this.customerNotic.shift();
      if (this.customerNotic.length > 0) {
        this.isShow = true;
      }
    },
    // 从公告列表里挑出需要弹窗展示的公告，依次展示
    isNeedShow() {
      if (this.customerNotic.length > 0) {
        return;
      }
      this.customerNotic = this.noticList.filter(
        (item) => item.isShow && !item.isNotToday,
      );
      if (this.customerNotic.length > 0) {
        this.isShow = true;
      }
    },
    rechargeMoney() {
      this.$router.push({ path: "/home/recharge" });
    },
    goToMoneylist() {
      this.$router.push({
        path: "/home/mymoneycenter",
        query: {
          ...this.customerMoneyInfo,
          selected: 0,
        },
      });
    },
    goToCommssionlist() {
      this.$router.push({
        path: "/home/commssioncenter",
        query: {
          ...this.customerMoneyInfo,
          selected: 0,
        },
      });
    },
    goShareCenter() {
      queryIsOpenShareCode()
        .then((res) => {
          if (res.success) {
            if (res.data) {
              this.$router.push({ path: "/home/sharemakemny" });
            } else {
              Dialog.alert({ message: "未开启邀请功能。" }).then(() => {
                //this.$router.back();
              });
            }
          }
        })
        .catch((err) => {
          MessageBox({
            title: "提示",
            message: err.message,
            showCancelButton: true,
          });
        });
    },
    connectService() {
      this.$router.push({
        path: "/home/connectservice",
        query: {
          userId: this.userInfo.userId,
        },
      });
    },
    bindAccountInfo() {
      this.showDialog = false;
      this.$router.push({ path: "/home/bindaccountinfos" });
    },
    idCardInfo() {
      this.showDialog = false;
      this.$router.push({ path: "/home/customerinfo" });
    },
    bindReciveMoney() {
      this.showDialog = false;
      this.$router.push({ path: "/home/recivemoney" });
    },
    showDialgWithCustomerInfo() {
      if (
        this.isUserStatus() ||
        !this.isBindAccount ||
        !this.isRecivewAccount
      ) {
        this.showDialog = true;
      }
    },
    logout() {
      this.$router.push({ path: "/" });
      sessionStorage.clear();
      window.location.reload(); //刷一下可以清空vuex-store
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../root.scss";

.center-main {
  background-color: rgb(249, 249, 249);
  // 固定定位，精确填满 tabbar 以上的全部空间
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 50px;
  bottom: calc(50px + env(safe-area-inset-bottom, 0px));
  display: flex;
  flex-direction: column;
  background-image: url(../../assets/img/thembg.png);
  background-repeat: no-repeat;
  background-size: contain;
}

// 顶部固定区域：头像 + 统计 + 功能按钮
.top-fixed {
  flex-shrink: 0;
  width: 100%;
}

// 底部可滚动区域：列表 + 注销按钮
.scroll-area {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 12px;
}

.border_postion {
  padding-top: 1px;
}

.person-card {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
}

.middle-car {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 10px;
  border-radius: 15px;
  background-color: rgb(154, 155, 156);
  font-size: calculeResultFontSize(false, 0px);
}

.person-card-content {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;

  .header-part {
    width: 100%;
    padding: 10px 3px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    color: #fff;
    .header-img {
      width: 64px;
      height: 64px;
      min-width: 48px;
      min-height: 48px;
      background-color: #fff;
      border-radius: 45px;
    }
    .header-body {
      margin-left: 5px;
      font-size: clamp(12px, 3.5vw, 16px);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      button {
        background-color: transparent;
        border: 0px solid #fff;
      }
    }
  }
}

.person-card-content-second {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  color: #fff;
  flex-shrink: 0;
  .line-area {
    height: 33px;
    border-right: 1px solid #e8e6e67e;
  }

  .item-second-content {
    text-align: center;
    font-size: calculeResultFontSize(false, 0px);
  }
}

.person-money,
.person-wallet {
  position: relative;
  margin: 5px;
}

.qr-contiuner {
  display: inline-grid;
  grid-template-row: 1fr 1fr;
}

.notice-content {
  max-height: 300px;
  overflow: auto;
  padding: 10px;
  border: 1px solid #eee;
  border-radius: 4px;
  line-height: 1.6;
}
/* 美化滚动条（可选） */
.notice-content::-webkit-scrollbar {
  width: 6px;
}
.notice-content::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 3px;
}

::v-deep .van-grid-item__content::after {
  border-width: 0;
}

::v-deep .van-grid-item__content {
  background-color: transparent;
}

::v-deep .van-cell,
.van-cell-group,
.van-cell__value,
.van-cell__right-icon,
.van-cell-group__title {
  background-color: transparent;
  color: #525050;
}

::v-deep [class*="van-hairline"]::after {
  border: 0;
  border-bottom: 1px solid rgb(31, 31, 31);
}
::v-deep.van-cell__left-icon {
  color: rgba(0, 0, 255, 0.572);
}

/* 权益统计 */
.benefit-arrow {
  transition: transform 0.25s ease;
}

.benefit-arrow--expanded {
  transform: rotate(90deg);
}

.benefit-table {
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 0 16px;
}

.benefit-loading-mask {
  position: absolute;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.7);
  z-index: 1;
}

.benefit-header,
.benefit-row {
  display: flex;
  align-items: center;
  padding: 6px 0;
}

.benefit-header {
  border-bottom: 1px solid #f0f0f0;
  padding-bottom: 8px;
  margin-bottom: 2px;
}

.benefit-row {
  border-bottom: 1px solid #f7f7f7;
}

.benefit-row:last-child {
  border-bottom: none;
}

.benefit-label {
  flex: 0 0 44px;
  font-size: 13px;
  color: #666;
  text-align: left;
}

.benefit-header .benefit-label {
  color: #999;
  font-size: 12px;
}

.benefit-value {
  flex: 1;
  font-size: 13px;
  color: #333;
  text-align: center;
}

.benefit-header .benefit-value {
  color: #999;
  font-size: 12px;
  font-weight: 500;
}

/* 小屏设备响应式调整 */
@media screen and (max-width: 375px) {
  .person-card-content .header-part .header-img {
    width: 48px;
    height: 48px;
  }
  .person-card-content .header-part .header-body {
    font-size: 12px;
  }
  .person-card-content-second .item-second-content {
    font-size: 11px;
  }
  ::v-deep .van-grid-item__content {
    padding: 8px 2px;
  }
  ::v-deep .van-grid-item__text {
    font-size: 11px;
  }
}

@media screen and (min-width: 376px) and (max-width: 414px) {
  .person-card-content .header-part .header-img {
    width: 56px;
    height: 56px;
  }
  .person-card-content-second .item-second-content {
    font-size: 13px;
  }
}
</style>
